// extracted by css-extract-rspack-plugin
export default {"actionItemList":"ActionItems-module__actionItemList__RF0vG"};